const VisaNet = () => import('@/components/buy/pasarelas/VisaNet');
const Paymentez = () => import('@/components/buy/pasarelas/Paymentez');
const DataFast = () => import('@/components/buy/pasarelas/data-fast');

export default {
	name: 'credit-card-distributor',
	props: {
		gatewayConfiguration: {
			type: Array,
			required: true,
		},
	},
	render(h) {
		const distributor = {
			visa: VisaNet,
			dataweb: DataFast,
			paymentez: Paymentez,
			// xchange: Xchange,
			// pagoplux: PagoPlux,
		};
		const selected = [];
		this.gatewayConfiguration.forEach((g) => {
			selected.push(h(distributor[g.code]));
		});
		return h(
			'div',
			{
				style: {
					display: 'grid',
					gridGap: '10px',
					gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
				},
			},
			selected,
		);
	},
};



// WEBPACK FOOTER //
// ./src/components/buy/creditCardDistributor.js